import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import Hero from "./components/Hero";
import CategoryStrip from "./components/CategoryStrip";
import LatestArticles from "./components/LatestArticles";
import SectTimeline from "./components/SectTimeline";
import RealmsShowcase from "./components/RealmsShowcase";
import Testimonials from "./components/Testimonials";
import FaqPreview from "./components/FaqPreview";

const ctaImg =
  "https://readdy.ai/api/search-image?query=Wide%20Chinese%20ink%20wash%20painting%20of%20warm%20misty%20mountain%20range%20with%20a%20distant%20rising%20sun%20glow%2C%20warm%20golden%20and%20cream%20paper%20tone%2C%20hand%20drawn%20brush%20strokes%2C%20serene%20traditional%20xianxia%20atmosphere%2C%20soft%20dreamy%20composition&width=1600&height=500&seq=cta-band-sxs&orientation=landscape";

export default function Home() {
  return (
    <>
      <Seo
        title="师兄啊师兄 - 宗门篇剧情讨论，修炼境界与主线剧情全梳理"
        description="师兄啊师兄漫画剧情深度讨论区，宗门篇发展脉络、修炼境界体系、主线剧情走向一网打尽。想看最新章节剧情解析、修仙线伏笔盘点，这里都有同好陪你聊透，追更不迷路。"
        keywords="师兄啊师兄,师兄啊师兄漫画剧情,师兄啊师兄宗门篇,师兄啊师兄修炼境界,师兄啊师兄主线剧情,师兄啊师兄最新章节剧情"
        path="/"
      />

      <Hero />
      <CategoryStrip />
      <LatestArticles />
      <SectTimeline />
      <RealmsShowcase />
      <Testimonials />
      <FaqPreview />

      <section className="relative w-full overflow-hidden">
        <div className="h-[300px] w-full md:h-[340px]">
          <img src={ctaImg} alt="师兄啊师兄追更讨论区水墨群山横幅" className="h-full w-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-foreground-950/45"></div>
        <div className="absolute inset-0 flex w-full items-center justify-center px-4">
          <div className="flex w-full flex-col items-center text-center">
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">看到这儿，聊聊你的想法？</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-background-200/90">
              分享你的剧情解读、伏笔发现或角色感悟，和更多同好一起把故事聊透。
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-chat-3-line text-base"></i>
                参与剧情讨论
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
              >
                了解这个讨论区
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}